import { Routes, Route, useLocation } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import "./App.css";
import Header from "./components/header";
import Announcement from "./components/announcement";
import Footer from "./components/footer";
import Home from "./pages/home";
import ScrollToTop from "./components/ScrollToTop";
import { ToastProvider } from "./components/Toaster";
import { applyPageMeta } from "./utils/pageMeta";

const Book = lazy(() => import("./pages/thebook"));
const Podcast = lazy(() => import("./pages/thepodcast"));
const About = lazy(() => import("./pages/about"));
const TheApp = lazy(() => import("./pages/theapp"));
const TheBlog = lazy(() => import("./pages/recipes"));
const BlogDetail = lazy(() => import("./pages/SingleBlog"));
const Contact = lazy(() => import("./pages/contact"));

const PAGE_META = {
  "/": {
    title:
      "The Plant-Based Switch | Podcast & App by Nafsika Antypas",
    description:
      "Make the switch to conscious living with The Plant-Based Switch. Listen to Nafsika’s podcast and explore daily menus, fitness, and wellness tools.",
  },
  "/about": {
    title:
      "About Nafsika Antypas | Host of The Plant-Based Switch",
    description:
      "Meet Nafsika Antypas, creator of A&E's first vegan lifestyle series, founder of Nafsika's Garden, and host of The Plant-Based Switch podcast and wellness app.",
  },
  "/the-book": {
    title: "The Plant-Based Switch Book by Nafsika Antypas",
    description:
      "Make the switch to vegan living with The Plant-Based Switch book by Nafsika Antypas. Get practical tips, easy recipes, and expert advice to start today.",
  },
  "/the-app": {
    title: "The Plant-Based Switch App | Vegan Menus & Wellness",
    description:
      "Get personalized vegan daily menus, wellness tracking, virtual workouts, and guided detox programs with The Plant-Based Switch app by Nafsika Antypas.",
  },
  "/the-podcast": {
    title: "The Plant-Based Switch Podcast | Nafsika Antypas",
    description:
      "Listen weekly as Nafsika Antypas talks with doctors, celebrities, and wellness experts about plant-based nutrition, health, and conscious living.",
  },
  "/recipes-and-lifestyle": {
    title: "Vegan Recipes & Lifestyle Tips | Plant-Based Switch",
    description:
      "Discover easy vegan recipes and plant-based lifestyle tips on food, wellness, fashion, home, and travel from Nafsika Antypas and The Plant-Based Switch.",
  },
  "/contact": {
    title: "Contact | The Plant-Based Switch",
    description:
      "Get in touch with The Plant-Based Switch. Send a message to Nafsika Antypas and the team about the podcast, app, book, or plant-based living.",
  },
};

function App() {
  const location = useLocation();

  useEffect(() => {
    const pathClass = location.pathname.replace(/\//g, "") || "home";
    document.body.className = "";
    document.body.classList.add(`page-${pathClass}`);

    const meta = PAGE_META[location.pathname];
    if (!meta) return;
    applyPageMeta({
      title: meta.title,
      description: meta.description,
      path: location.pathname,
    });
  }, [location]);

  return (
    <ToastProvider>
      <Announcement />
      <Header />
      <ScrollToTop />
      <main>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/the-podcast" element={<Podcast />} />
            <Route path="/the-book" element={<Book />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/the-app" element={<TheApp />} />
            <Route path="/recipes-and-lifestyle" element={<TheBlog />} />
            <Route path="/blog/:handle" element={<BlogDetail />} />
          </Routes>
          {location.pathname !== "/" && <Footer />}
        </Suspense>
      </main>
    </ToastProvider>
  );
}

export default App;

// import { Routes, Route, useLocation } from "react-router-dom";
// import { useEffect } from 'react';
// import './App.css';
// import Header from "./components/header";
// import Announcement from "./components/announcement";
// import Footer from "./components/footer";
// import Home from "./pages/home";
// import Book from "./pages/thebook";
// import Podcast from "./pages/thepodcast";
// import About from "./pages/about";
// import TheApp from "./pages/theapp";
// import ScrollToTop from "./components/ScrollToTop";
// import TheBlog from "./pages/recipes";
// import BlogDetail from "./pages/SingleBlog";

// function App() {
//   const location = useLocation();

//   useEffect(() => {
//     const pathClass = location.pathname.replace(/\//g, '') || 'home';
//     document.body.className = '';
//     document.body.classList.add(`page-${pathClass}`);
//   }, [location]);
//   return (
//     <>
//     < Announcement />
//       <Header />
//       <ScrollToTop />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/the-podcast" element={<Podcast />} />
//         <Route path="/the-book" element={<Book />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/the-app" element={<TheApp />} />
//         <Route path="/recipes-and-lifestyle" element={<TheBlog />} />
//         {/* <Route path="/blogs/:handle" element={<BlogDetail />} /> */}
//         <Route path="/blog/:handle" element={<BlogDetail />} />
//       </Routes>
//       <Footer />
//     </>
//   );
// }

// export default App;
